import { EXPORT_TYPE_NAMES, ReportNames } from 'constants/exportTypes';

import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { getUserInfo } from 'config/requests';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { SortPayload, useListController } from 'react-admin';
import { Typography } from 'shared/mui/Typography';
import { ExportEditButton } from 'shared/react-admin/Export/ExportEditButton/ExportEditButton';
import { ListPage } from 'shared/react-admin/Pages';
import { ReportExportDialog } from 'shared/widgets/ReportExportDialog/ReportExportDialog';
import { Order } from 'types/embedded/order';

import { OrdersListActions } from './OrdersListActions';
import { OrdersListContent } from './OrdersListContent';
import { EXPORT_FIELDS_ORDERS } from '../constants/exportFields';
import { useOrdersReportExport } from './OrdersListLocalDatagrid/hooks/useOrdersReportExport';
import { getFilterDefaultValues } from './utils/getFilterDefaultValues';

export const OrdersList = (): JSX.Element => {
  const translate = useTypedTranslate();

  const filterDefaultValues = getFilterDefaultValues();

  const { filterValues } = useListController<Order>({
    filterDefaultValues,
    resource: 'orders/list',
    queryOptions: { enabled: false },
  });

  const [isOpenNotifyDialog, setIsOpenNotifyDialog] = useState(false);

  const {
    exportMutate,
    setExportType,
    isExportLoading,
    setIsSendReportOnEmail,
    exportType,
    isSendReportOnEmail,
  } = useOrdersReportExport({ onSuccess: () => setIsOpenNotifyDialog(false) });

  const isListFilterExist = Object.keys(filterValues).length > 0;
  const { data: user } = useQuery({ queryKey: ['me'], queryFn: getUserInfo });

  return (
    <ListPage
      actions={[
        <OrdersListActions
          exportType={exportType}
          key="orders_actions"
          onExportTypesButtonClick={() => setIsOpenNotifyDialog(true)}
          setExportType={setExportType}
        />,
      ]}
      empty={false}
      filterDefaultValues={filterDefaultValues}
      headerTitle={{ titleText: translate('app.orders.orders') }}
      pagination={<></>}
      queryOptions={{ enabled: isListFilterExist }}
      resource="orders/list"
      sort={{} as SortPayload}
    >
      <OrdersListContent setIsOpenNotifyDialog={setIsOpenNotifyDialog} />
      <ReportExportDialog
        exportType={EXPORT_TYPE_NAMES[exportType]}
        isLoading={isExportLoading}
        onChange={() => setIsSendReportOnEmail((prev) => !prev)}
        onClose={() => setIsOpenNotifyDialog(false)}
        onSubmit={exportMutate}
        open={isOpenNotifyDialog}
        sendOnEmail={isSendReportOnEmail}
        title={
          <>
            <Typography component="span" sx={{ verticalAlign: 'middle' }} variant="inherit">
              {translate('app.orders.exportReport')}
            </Typography>
            <ExportEditButton fields={EXPORT_FIELDS_ORDERS} preferenceKey={ReportNames.Orders} />
          </>
        }
        userEmail={user?.corporateEmail || user?.email}
      />
    </ListPage>
  );
};
